/* Фирмени покани: истински режим (вход от „Моите покани“, запазване в базата, отговори на гости).
   Ползва същия вход и същите сесии като сватбените покани (pokani-editor-api), без да ги променя.
   Зарежда се ПРЕДИ firmena-editor.js / firmena-tablo.js. В демото (без билет/сесия/адрес) не прави нищо. */
(function () {
  'use strict';
  var html = document.documentElement;
  var role = html.dataset.firmenaRole || '';
  if (!role) return;

  var CFG = window.POKANI || {};
  var SB_URL = String(CFG.url || '').replace(/\/+$/, '');
  var SB_KEY = String(CFG.key || '');
  var ONLINE = /^https:\/\/[a-z0-9-]+\.supabase\.co$/.test(SB_URL) && SB_KEY.length > 20;
  var API = SB_URL + '/functions/v1/pokani-editor-api';
  var HEX64 = /^[0-9a-f]{64}$/;
  var SESS_KEY = 'firmena-sess';
  var ACCOUNT_URL = 'https://account.karticharnitsa.com/pages/01a19c47-415e-772e-b8e3-2d5181537e18';
  var PAGES = { tablo: 'firmeno-tablo', editor: 'firmena-redakcia', guest: 'firmena-pokana' };
  var VIEWS = { tablo: 'firmena-tablo', editor: 'firmena-redakcia', guest: 'firmena-pokana' };

  var params = new URLSearchParams(location.search);
  var preview = params.has('view') || location.pathname.indexOf('/pages/contact') === 0;
  var ticket = (location.hash.match(/(?:^#|&)ticket=([0-9a-f]{64})(?:&|$)/) || [])[1] || null;
  var stored = null;
  try { stored = sessionStorage.getItem(SESS_KEY); } catch (e) {}
  if (stored && !HEX64.test(stored)) stored = null;
  var slug = params.get('s') || '';

  var live = role === 'guest' ? /^[a-z0-9]+(-[a-z0-9]+)*$/.test(slug) && slug.length <= 200 : Boolean(ticket || stored || !preview);
  if (!live) return;

  globalThis.CORPORATE_LIVE = role;
  html.dataset.firmenaLive = role;

  function pageUrl(kind, extra) {
    var u;
    if (preview) {
      u = new URL(location.pathname, location.origin);
      u.searchParams.set('view', VIEWS[kind]);
      var themeId = params.get('preview_theme_id');
      if (themeId) u.searchParams.set('preview_theme_id', themeId);
    } else {
      u = new URL('/pages/' + PAGES[kind], location.origin);
    }
    Object.keys(extra || {}).forEach(function (k) { u.searchParams.set(k, extra[k]); });
    return u.href;
  }
  function guestUrl(s, lang) {
    if (!s) return '';
    // Кратък линк като при сватбите: /a/p/<фирма> и /a/p/<фирма>/en
    if (!preview && /^[a-z0-9]+(-[a-z0-9]+)*$/.test(s) && s.length <= 200) {
      return 'https://karticharnitsa.com/a/p/' + s + (lang === 'en' ? '/en' : '');
    }
    var u = new URL('/pages/' + PAGES.guest, 'https://karticharnitsa.com');
    if (preview) { u = new URL(pageUrl('guest')); }
    u.searchParams.set('s', s);
    if (lang === 'en') u.searchParams.set('lang', 'en');
    return u.href;
  }

  var sess = null;
  function endSession() { sess = null; try { sessionStorage.removeItem(SESS_KEY); } catch (e) {} }

  async function api(action, extra, bearer) {
    var ctl = new AbortController();
    var tm = setTimeout(function () { ctl.abort(); }, 20000);
    var r;
    try {
      r = await fetch(API, {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + (bearer || sess), apikey: SB_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ action: action }, extra || {})),
        signal: ctl.signal
      });
    } catch (e) { throw new Error('network'); } finally { clearTimeout(tm); }
    var j = null;
    try { j = await r.json(); } catch (e) {}
    if (r.status === 401) { endSession(); throw new Error('401'); }
    if (!r.ok || !j || j.ok !== true) throw new Error('unconfirmed');
    return j;
  }
  async function rpc(name, args) {
    var ctl = new AbortController();
    var tm = setTimeout(function () { ctl.abort(); }, 20000);
    var r;
    try {
      r = await fetch(SB_URL + '/rest/v1/rpc/' + name, {
        method: 'POST',
        headers: { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify(args),
        signal: ctl.signal
      });
    } catch (e) { throw new Error('network'); } finally { clearTimeout(tm); }
    var j = null;
    try { j = await r.json(); } catch (e) {}
    if (!r.ok) {
      var m = j && (j.message || j.hint || '');
      throw new Error(String(m || 'unconfirmed'));
    }
    return j;
  }

  function isCorporate(data) {
    return data && typeof data === 'object' && (Object.keys(data).length === 0 || data.kind === 'corporate' || data.publicAlias && Object.keys(data).length === 1);
  }
  function friendly(e) {
    var m = String(e && e.message || '');
    if (m === '401') return 'Достъпът изтече или линкът вече е използван. Отворете поканата отново от „Моите покани“ във Вашия профил.';
    if (m === 'network') return 'Няма връзка. Проверете интернета и опитайте отново.';
    if (m === 'not-corporate') return 'Тази покана не е фирмена. Отворете я от „Моите покани“.';
    return 'Не успяхме да потвърдим операцията. Опитайте отново след малко.';
  }

  // Име за адреса: фирма + дата, например atelie-ekip-18-12-2026
  function slugFor(data) {
    var M = globalThis.CORPORATE_MODEL;
    var base = M && M.asciiSlug ? M.asciiSlug(String(data.company || '')) : '';
    // Само името на фирмата; при заето име базата добавя -2, -3 ...
    return (base || 'firmena-pokana').slice(0, 74).replace(/-+$/, '');
  }

  async function boot() {
    if (!ONLINE) throw new Error('offline');
    if (role === 'guest') {
      var data = await rpc('get_invitation', { p_slug: slug });
      if (!data || typeof data !== 'object' || data.kind !== 'corporate') throw new Error('guest-missing');
      return { data: data };
    }
    if (location.hash) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
    if (ticket) {
      var j = await api('redeem', {}, ticket);
      if (!HEX64.test(j.sessionToken || '')) throw new Error('unconfirmed');
      sess = j.sessionToken;
      try { sessionStorage.setItem(SESS_KEY, sess); } catch (e) {}
    } else if (stored) {
      sess = stored;
    } else {
      throw new Error('no-session');
    }
    var got = await api('get', {});
    var inv = got.result;
    if (!inv || typeof inv !== 'object') throw new Error('401');
    if (!isCorporate(inv.data || {})) throw new Error('not-corporate');
    return { inv: inv };
  }

  var ready = boot();

  // Запазване: пази масите, записани от таблото, и дава адрес при първото публикуване
  async function save(data, opts) {
    opts = opts || {};
    var fresh = (await api('get', {})).result || {};
    var old = fresh.data || {};
    if (!isCorporate(old)) throw new Error('not-corporate');
    var next = Object.assign({}, data || old);
    next.kind = 'corporate';
    if (old.seatingPlan && !opts.seatingPlan) next.seatingPlan = old.seatingPlan;
    if (opts.seatingPlan) next.seatingPlan = opts.seatingPlan;
    if (old.showSeatingList !== undefined && opts.showSeatingList === undefined) next.showSeatingList = old.showSeatingList;
    if (opts.showSeatingList !== undefined) next.showSeatingList = opts.showSeatingList;
    var body = { data: next };
    if (typeof opts.published === 'boolean') body.published = opts.published;
    if (!fresh.slug && (opts.published || next.company)) body.slug = slugFor(next);
    var res = await api('save', body);
    var out = (await api('get', {})).result;
    return out || res;
  }
  async function rsvps() {
    var j = await api('rsvps', {});
    return Array.isArray(j.result) ? j.result : [];
  }
  async function logout() {
    try { await api('logout', {}); } finally { endSession(); }
  }
  async function submitRsvp(args) {
    return rpc('corporate_submit_rsvp', {
      p_slug: slug,
      p_attending: args.attending,
      p_details: args.details,
      p_message: args.message || null,
      p_answers: args.answers || []
    });
  }

  globalThis.CORPORATE_SESSION = {
    role: role,
    ready: ready,
    save: save,
    rsvps: rsvps,
    logout: logout,
    submitRsvp: submitRsvp,
    pageUrl: pageUrl,
    guestUrl: guestUrl,
    accountUrl: ACCOUNT_URL,
    friendly: friendly,
    slug: slug
  };

  // Видимо съобщение при грешка
  ready.catch(function (e) {
    var m = String(e && e.message || '');
    var text = m === 'guest-missing'
      ? 'Поканата не е намерена или още не е публикувана. Проверете линка от организатора.'
      : m === 'no-session'
        ? 'Отворете поканата от „Моите покани“ във Вашия профил в магазина.'
        : m === 'offline'
          ? 'Онлайн поканите временно не са достъпни.'
          : friendly(e);
    function show() {
      var box = document.createElement('div');
      box.className = 'fm-live-error';
      box.setAttribute('role', 'alert');
      box.innerHTML = '<p></p>' + (role === 'guest' ? '' : '<a href="' + ACCOUNT_URL + '">Към „Моите покани“</a>');
      box.firstChild.textContent = text;
      document.body.appendChild(box);
      html.dataset.firmenaFailed = '1';
    }
    if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);
  });
})();
